import React from 'react'

type Props = { error?: Error, message?: string | React.ReactNode }
const ErrorMessage: React.FC<Props> = ({ error, message }) => {
  return (
    <div className='p-2 text-center'>
      <span className='text-burnt-orange'>{error ? error.message : message?.toString()}</span>
    </div>
  )
}

export default ErrorMessage
